import { isCleanOverUnderLine } from '../over-under/over-under.js';
const key = (value) => value.trim().toLowerCase();
const resolveSide = (market, outcomeName) => {
    const outcome = key(outcomeName);
    if (outcome === '')
        return null;
    if (outcome === key(market.homeTeam))
        return 'HOME';
    if (outcome === key(market.awayTeam))
        return 'AWAY';
    return null;
};
/**
 * Freezes a Spread Reel Option's side and its signed handicap (CAE-1632).
 *
 * Caesars serve a full-game Spread as one signed `line` on the market and two
 * selections named after the bare clubs. The line is the home team's handicap
 * and the away team carries its negation: checked against the Money Line
 * favourite on every captured WNBA game (`wnba-2026-09-30` fixtures) and, in
 * caesars-supernova, on 95 of 95 NFL and MLB fixtures (CAE-1481). A selection
 * that names neither club, or a line on a quarter point, freezes nothing, so
 * the option can never be graded on a guessed proposition.
 */
export const resolveSpread = (market, outcomeName) => {
    if (market.selections.length !== 2) {
        return { ok: false, reason: 'not_spread_shape' };
    }
    const sides = market.selections.map((selection) => resolveSide(market, selection.name));
    if (!sides.includes('HOME') || !sides.includes('AWAY')) {
        return { ok: false, reason: 'not_spread_shape' };
    }
    const side = resolveSide(market, outcomeName);
    if (side === null) {
        return { ok: false, reason: 'unresolved_side' };
    }
    if (market.line === null || !Number.isFinite(market.line)) {
        return { ok: false, reason: 'unresolved_line' };
    }
    if (!isCleanOverUnderLine(market.line)) {
        return { ok: false, reason: 'quarter_line' };
    }
    // Adding zero turns the `-0` of a pick'em line into a plain zero.
    const line = side === 'HOME' ? market.line : -market.line + 0;
    const metadata = { settlementType: 'SPREAD', side, line };
    return { ok: true, metadata };
};
export const parseSpreadSettlementMetadata = (value) => {
    if (value === null || typeof value !== 'object') {
        return null;
    }
    const metadata = value;
    if (metadata.settlementType !== 'SPREAD' ||
        (metadata.side !== 'HOME' && metadata.side !== 'AWAY') ||
        typeof metadata.line !== 'number' ||
        !Number.isFinite(metadata.line)) {
        return null;
    }
    return { settlementType: 'SPREAD', side: metadata.side, line: metadata.line };
};
/**
 * Grades a Spread pick from the game's home margin (home points minus away
 * points) against the side's own frozen line. The side covers when its margin
 * plus its handicap is above zero. Exactly zero is a push, which a half-point
 * line cannot produce; on a whole-number line it settles as void (CAE-1632).
 */
export const deriveSpreadResult = (input) => {
    const sideMargin = input.side === 'HOME' ? input.homeMargin : -input.homeMargin;
    const covered = sideMargin + input.line;
    if (covered === 0)
        return 'VOID';
    return covered > 0 ? 'WIN' : 'LOSE';
};
//# sourceMappingURL=spread.js.map